import axios from 'axios';
export const baseURL = 'https://api.ondeestameutrem.metrorio.app';
const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbXByZXNhIjoibWFnYWx1IiwiYWRtaW5pc3RyYWRvciI6ZmFsc2UsImlkRW1wcmVzYSI6OCwiaWF0IjoxNjI3NDU2ODY3LCJleHAiOjI1NzQxODQ4Njd9.BHFDSau6nXos7U_SIa7zVWoOgl6DPIsmeu6v3YMdqss';

const client = withoutHeaders => axios.create({
  baseURL: baseURL,
  timeout: 15000,
  headers: withoutHeaders ? {} : {"Authorization":`Bearer ${ token }`}
});

export default client; 